import SimplexNoise from 'simplex-noise';

export const simplex = new SimplexNoise('seed');
